import React, { useEffect, useRef, useState } from 'react'
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";
import gsap from 'gsap';

let checkoutAnimation = false
export const ButtonValidate = ({ name = "Continuar", callback = () => { } }) => {
	const animationRef = useRef(null);
	const [activateButtonAnimation, setActivateButtonAnimation] = useState(false);

	ObserverEmitter.on(EVENTS.activeButtonValidate, (activate = false) => {
		// console.log(activate);
		setActivateButtonAnimation(activate)
	})
	useEffect(() => {
		if (!activateButtonAnimation) {
			// console.log("stop");
			stopAnimation()
			return
		}
		// console.log("activate");
		if (checkoutAnimation) {
			return
		}
		gsapAnimation()
	}, [activateButtonAnimation])



	const gsapAnimation = () => {
		checkoutAnimation = true
		animationRef.current = gsap.to(`#ButtonValidate`, {
			duration: 0.5,
			scale: 0.8,
			backgroundColor: "#FFC427",
			repeat: -1,
			yoyo: true,
		});
	};

	const stopAnimation = () => {
		checkoutAnimation = false
		gsap.set(`#ButtonValidate`, {
			scale: 1,
			backgroundColor: "#9A9A9A",
		});
		if (animationRef.current) {
			animationRef.current.kill();
			animationRef.current = null;

		}
	};

	return (
		<div className="fixed bottom-0 right-0 z-40 w-[20%] flex items-end md:px-12 pb-4">
			<button
				id="ButtonValidate"
				onClick={() => {
					ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
					if (!activateButtonAnimation) {
						return
					}
					callback();
				}}
				className="boxShadowButtons bg-[#FFC427] w-full text-white text-[12px] md:text-xl font-semibold rounded-lg py-2"
			>
				{name}
			</button>
		</div>
	)
}
